import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const title: any = to.meta?.title || '数字能源'
  document.title = title
  next()
})

router.afterEach(() => {
  NProgress.done()
})
